import { image, text } from '@pdfme/schemas';

import boolean from './plugins/boolean';
import date from './plugins/date';
import fixedText from './plugins/fixedText';
import number from './plugins/number';
import shortText from './plugins/shortText';

export const DESIGNER_PLUGINS = {
  'Short text': shortText,
  'Long text': text,
  'Fixed text': fixedText,
  Numeric: number,
  Date: date,
  'True/False': boolean,
  Image: image,
};
